/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { signout } from '../../../states/action_creators';
import { useFetchUserProfile } from '../../../hooks/account_settings/useFetchUserProfile';

const HeaderUserMenu: FC = () => {
  const dispatch = useDispatch();
  const logout = () => dispatch(signout());

  const { userProfile }: any = useFetchUserProfile()

  return (
    <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px' data-kt-menu='true'>
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5 text-capitalize'>
              {`${userProfile?.firstname} ${userProfile?.lastname}`}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>{userProfile?.user_type?.name}</span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {userProfile?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-3'>
        <Link to='/settings/profile' className='menu-link px-5'>
          <i className='bi bi-person me-2 fs-4'></i> <span className='fs-7'>My Profile</span>
        </Link>
      </div>

      <div className='menu-item px-3 my-1'>
        <Link to='/settings/profile' className='menu-link px-5'>
          <i className='bi bi-gear me-2 fs-4'></i> <span className='fs-7'>Account Settings</span>
        </Link>
      </div>

      <div className='menu-item px-3'>
        <a onClick={logout} className='menu-link px-5'>
          <i className='bi bi-power me-2 fs-4'></i> <span className='fs-7'>Logout</span>
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
